import React from 'react'
import PropTypes from 'prop-types'

function VideoBlockTypeIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={22}
      height={19}
      viewBox="0 0 25 21"
      fill="none"
      className={className}
    >
      <path
        d="M25 0V20.25H0V0H25ZM2.5 2.50493V17.7852H22.5V2.50488H2.5V2.50493Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9965 10.1875L10.0146 5.5V14.875L16.9965 10.1875Z"
        fill="currentColor"
      />
    </svg>
  )
}

VideoBlockTypeIcon.propTypes = {
  className: PropTypes.string,
}

VideoBlockTypeIcon.defaultProps = {
  className: undefined,
}

function OtherBlockTypeIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={22}
      height={15}
      viewBox="0 0 30 20"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 0V20H0V0H30ZM28.2031 1.81384H1.79688V18.2339H28.2031V1.81384ZM19.2344 12.681V14.4789H6.39062V12.681H19.2344ZM23.5312 9.08512V10.8831H6.39062V9.08512H23.5312ZM19.2344 5.48926V7.28719H6.39062V5.48926H19.2344Z"
        fill="currentColor"
      />
    </svg>
  )
}

OtherBlockTypeIcon.propTypes = {
  className: PropTypes.string,
}

OtherBlockTypeIcon.defaultProps = {
  className: undefined,
}

export default function LearningHubBlockTypeIcon({ blockType, className }) {
  if (blockType === 'video') {
    return <VideoBlockTypeIcon className={className} />
  }
  return <OtherBlockTypeIcon className={className} />
}

LearningHubBlockTypeIcon.propTypes = {
  blockType: PropTypes.string,
  className: PropTypes.string,
}

LearningHubBlockTypeIcon.defaultProps = {
  blockType: '',
  className: undefined,
}
